export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privacy Policy"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offer Agreement"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powered by Skillspace"])}
        }
      },
      "ru": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Политика конфиденциальности"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Договор-оферта"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Работает на платформе Skillspace"])}
        }
      },
      "es": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Política de privacidad"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acuerdo de oferta"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Funciona en la plataforma Skillspace"])}
        }
      },
      "kk": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Құпиялық саясаты"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ұсыныс келісімі"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace платформасында жұмыс істейді"])}
        }
      },
      "uz": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maxfiylik siyosati"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taklif shartnomasi"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skillspace platformasida ishlaydi"])}
        }
      },
      "de": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzrichtlinie"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angebotsvereinbarung"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bereitgestellt von Skillspace"])}
        }
      },
      "fr": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politique de confidentialité"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrat d'offre"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propulsé par Skillspace"])}
        }
      },
      "it": {
        "footer": {
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informativa sulla privacy"])},
          "offerAgreement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contratto di offerta"])},
          "poweredBySkillspace": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supportato dalla piattaforma Skillspace"])}
        }
      }
    }
  })
}
